const data = {
  'title': 'Bitcoin Dojo',
  'content': 'Educational platform for Rust devs to learn Bitcoin protocol development',
  'github': 'https://github.com/Bitcoin-Dojo',
  'live': 'https://bitcoindojo.dev/',
  'technologies': [
    'Bitcoin',
    'Rust',
    'AWS',
    'TypeScript',
    'Python'
  ],
}

export default data
